import styles from "./genotpblock.module.css";
import LoginWithGoogleButton from "../LoginWithGoogleButton";
import LoginWithFacebookButton from "../LoginWithFacebookButton";
import LoginWithTiktokButton from "../LoginWithTiktokButton";
import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";
import SignupVerifyBlock from "../SignupVerifyBlock";
import { useLocation, useSearchParams } from "react-router-dom";
import QRCode from "react-qr-code";

export default function GenOTPBlock() {
  const { t } = useTranslation();

  const [showOTPForm, setShowOTPForm] = useState(false);

  const [params, setSearchParams] = useSearchParams();

  const qrcodeImg = params.get('uri')
  const userId = params.get('userId')
  const error = params.get('error')

  return showOTPForm
    ? <SignupVerifyBlock userId={userId} />
    : <div className={styles.signupBlock}>
      <h2 className={styles.signupText}>{t("signup")}</h2>

      {qrcodeImg ? <>
        <div className={`col-11 ${styles.inputBlock}`}>
          <QRCode value={qrcodeImg} />
        </div>
        <p className={styles.tosInfo}>
          {t("saved_otp")}
        </p>
        <div className={`col-12 ${styles.signupButtonContainer}`}>
          <button type="button" className="btn btn-success" onClick={() => { setShowOTPForm(true) }}>{t("continue")}</button>
        </div>
      </>
        : <span className={`col-12 ${styles.errorText}`}>{t(error)}</span>
      }
      {/* <div className={`col-12 ${styles.hrContainer}`}>
        <hr className={styles.leftHr} />
        <span className={styles.hrText}>{t("or")}</span>
        <hr className={styles.rightHr} />
      </div>
      <div className={`col-12 ${styles.loginWithBlock}`}>
        <div className={`col-9 ${styles.loginWithContainer}`}>
          <LoginWithGoogleButton />
        </div>
        <div className={`col-9 ${styles.loginWithContainer}`}>
          <LoginWithFacebookButton />
        </div>
        <div className={`col-9 ${styles.loginWithContainer}`}>
          <LoginWithTiktokButton />
        </div>
      </div> */}
      <p className={styles.tologinPage}>
        {t("have_account_already")} <a href="/login">{t("login")}</a>
      </p>
    </div>
}
